import React from 'react';
import collaborativelogo from '../../../../Assets/Images/COLLABORATIVE.png';
import stratrgiclogo from '../../../../Assets/Images/STRATEGIC.png';
import visionarylogo from '../../../../Assets/Images/VISIONARY.png';
import performancelogo from '../../../../Assets/Images/PERFORMANCE.png';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

const Arrow = () => (
  <svg width="70" height="28" viewBox="0 0 70 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
    <line x1="0" y1="12" x2="70" y2="12" stroke="#245775" strokeWidth="3.6" />
    <path d="M30 3L40 12L30 21" fill="none" stroke="#245775" strokeWidth="3.6" />
  </svg>
);

export default function LeadershipFlowResults({ leadershipSnapshotResults, leadershipLabels }) {
  const paired = leadershipLabels.map((label, i) => ({
    label,
    percent: leadershipSnapshotResults[i],
  }));
  // Keep the clockwise order when all four styles tie
  const sorted = applyFullTieOrder(paired.sort((a, b) => b.percent - a.percent), (p) => p.label, (p) => p.percent);

  const imagesMap = {
    collaborative: { icon: collaborativelogo, label: "Collaborative" },
    strategic: { icon: stratrgiclogo, label: "Strategic" },
    visionary: { icon: visionarylogo, label: "Visionary" },
    performance: { icon: performancelogo, label: "Performance" },
  };

  const sortedScores = sorted.map((item) => ({
    name: String(item.label || '').toLowerCase(),
    value: Number(item.percent) || 0,
  }));
  const sortedImages = sortedScores.map((item) => imagesMap[item.name]);

  const sizeSequence = [88, 64, 50, 28];
  const minSize = sizeSequence[sizeSequence.length - 1];
  const imageSizes = sortedImages.map((_, index) => (
    sizeSequence[index] || Math.max(minSize, 88 - index * 30)
  ));
  const itemWidth = Math.max(...imageSizes);

  return (
    <div style={{
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: "40px auto",
    }}>
      <p style={{
        fontSize: '11px',
        fontWeight: 700,
        color: '#245775',
        fontFamily: 'Helvetica',
        margin: 0,
        marginBottom: '8px',
        alignSelf: "flex-start",
        paddingLeft: "7%",
      }}>Start</p>
      <div style={{
        width: "100%",
        display: 'flex',
        flexDirection: "row",
        gap: "57px",
        alignItems: "center",
        justifyContent: "start"
      }}>
        {sortedImages?.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
            }}
          >
            <img
              src={item?.icon}
              alt={item?.label || ''}
              style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex: "9999" }}
            />
            {index < sortedImages?.length - 1 && (
              <div style={{
                position: "absolute",
                top: `${imageSizes[index] / 2}px`,
                left: index === 0
                  ? "80px"
                  : index === 1
                    ? "60px"
                    : index === 2
                      ? "48px"
                      : "0px",
                width: index === 2 ? "82px" : "74px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <span style={{
                  position: "absolute",
                  fontSize: 50,
                  fontWeight: 300,
                  top: -30,
                  left: 0,
                  color: "#245775",
                  fontFamily: 'Helvetica'
                }}>
                  <Arrow />
                </span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{
        width: "100%",
        display: 'flex',
        flexDirection: "row",
        gap: "58px",
        alignItems: "center",
        justifyContent: "start",
        paddingTop:"10px"
      }}>
        {sortedImages.map((item, index) => (
          <div key={index} style={{
            display: 'flex',
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            width: `${imageSizes[index]}px`,
          }}>
            <div style={{
              marginTop: '5px',
              textAlign: 'center',
              width: `${imageSizes[index]}px`,
              minWidth: "fit-content",
            }}>
              <p style={{
                margin: 0,
                lineHeight: '18px',
                fontWeight: 700,
                fontSize: '11px',
                color: '#245775',
                fontFamily: 'Helvetica'
              }}>{item?.label}</p>
              <p style={{
                margin: 0,
                fontSize: '11px',
                color: '#5795B2',
                fontWeight: 400,
                textAlign: 'center',
                lineHeight: '18px',
                fontFamily: 'Helvetica'
              }}>{typeof sortedScores[index]?.value === 'number' ? parseFloat(sortedScores[index].value).toFixed(2) : parseFloat(sortedScores[index]?.value).toFixed(2)}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
